import React from "react";
import styles from "./OurManufacturingNetwork.module.scss";

const networks = [
  { id: 1, count: 400, title: "Manufacturing facilities" },
  { id: 1, count: 30, title: "Reaction Capabilities" },
  { id: 1, count: 15, title: "Testing and analytical equipments" },
  { id: 1, count: 1000, title: "Products" },
];

const NetworkCard = ({ network }) => {
  return (
    <div className={styles.networkCard}>
      {/* Count */}
      <div className={styles.count}>
        {network.count}
        {"+"}
      </div>
      {/* Title */}
      <div className={styles.title}>{network.title}</div>
    </div>
  );
};

function OurManufacturingNetwork() {
  return (
    <div className={styles.ourManufacturingNetwork}>
      {/* Heading */}
      <h2>Our Manufacturing Network</h2>
      {/* Row of Network Cards */}
      <div className={styles.networkCardsRow}>
        {networks.map((network) => (
          <NetworkCard key={network.id} network={network} />
        ))}
      </div>
    </div>
  );
}

export default OurManufacturingNetwork;
